export default __webpack_public_path__ + "static/media/appstore.734ad6bb.svg";